import ICommonFormProps from '../../../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps';
import FormChipInput from '../../../../ui/FormChipInput';
import { useWatch } from 'react-hook-form';
import { useEffect, useContext } from 'react';
import AddNewUsersContext from './AddNewUsers.context';
import { updateEmailList } from './AddNewUsers.actions';
import { validateEmail } from './utils';
import { useTranslation } from "react-i18next";

const EmailChipInput = (props: ICommonFormProps) => {
  const { t } = useTranslation();
  const { dispatch } = useContext(AddNewUsersContext);
  const email_list = useWatch({ control: props.control,name: 'email_list' });
 
  useEffect(() => {
    dispatch(updateEmailList(email_list));
  }, [email_list, dispatch])

  const inputProps = {
    ...props, 
    prevChipList : email_list
  }

  return (
    <FormChipInput 
      title={t("userManagement.emailInput.title")}
      placeholderText={t("userManagement.emailInput.placeholder")}
      itemValidation={validateEmail}
      {...inputProps}
    />
  );
}

export default EmailChipInput;
